import React, { useState } from "react";
import DashCard from "../../../Components/share/cards/DashCard";
import SaveBootcamps from "../../../Components/layouts/StudentDashboard/SaveBootcamps";
import AdminPagination from "../../../Components/share/Pageination/AdminPagination";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../../Components/share/Pageination/MainPagination";

function SaveBootCamp(props) {
    const [bookmarks, setBookmarks] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const bookmakredCourse = useFetch({
        method: "GET",
        url: "BootCampService/bookmarks",
        noHeader: false,
        trigger: true,
        setter: setBookmarks,
    });

    console.log(bookmarks);

    return (
        <div>
            {" "}
            <h4 className="text-[2rem] text-black-prim font-bold mb-16">
                بوت کمپ های ذخیره شده
            </h4>
            <div className=" grid grid-cols-2 gap-[5.4rem]">
                {bookmarks?.results.map((item, index) => (
                    <DashCard
                        className="flex py-10 px-12 flex-col"
                        topRightsmall
                    >
                        <SaveBootcamps item={item} />
                    </DashCard>
                ))}
            </div>
            <MainPagination
                pagination={pagination}
                setPagination={setPagination}
                data={bookmarks?.results}
                pageSize={bookmarks?.page_count}
                className=" mt-[3rem]"
            />
        </div>
    );
}

export default SaveBootCamp;
